import React from 'react'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import Layout from '../../layouts/layout'
import Hero from '../../components/hero'
import AwardsArchive from './components/awards-archive'
import SEO from '../../components/seo'
import ToTop from '../../layouts/totop'
import {
  contentfulImageSrcSet,
  contentfulImageUrl,
} from '../../lib/contentful-image'
import '../base.css'
import './awards.css'

const AwardsPage = ({ data, location }) => {
  const hero = data.allContentfulHero.edges.map(({ node }) => ({
    node: {
      ...node,
      quote: (node.quote || '').replace('，于是，', '\n于是，'),
    },
  }))
  const background = hero[0].node.bg

  return (
    <Layout
      location={location}
      socialmedias={data.allContentfulSocialMedia.edges}
    >
      <SEO
        title="但行耕耘 - 张喆的荣誉墙"
        pathname="/awards/"
        description="张喆的奖项与荣誉记录。让他着迷的是结果之外的一切。"
      />
      <Helmet bodyAttributes={{ class: 'AwardsPageDocument' }}>
        <link
          rel="preconnect"
          href="https://images.ctfassets.net"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          as="image"
          href={contentfulImageUrl(background.fluid.src, 960, 45)}
          imageSrcSet={contentfulImageSrcSet(
            background.fluid.src,
            [480, 640, 960, 1280],
            45
          )}
          imageSizes="100vw"
        />
      </Helmet>
      <ToTop />
      <main className="AwardsPage">
        <Hero data={hero} textScale={1.4} mobileTextScale={1.1} />
        <section className="Awards AwardsCollection" aria-label="奖状">
          <AwardsArchive data={data.allContentfulAward.edges} />
        </section>
      </main>
    </Layout>
  )
}

export default AwardsPage

export const pageQuery = graphql`
  query AwardsQuery {
    allContentfulHero(
      sort: { fields: [createdAt], order: ASC }
      filter: { page: { eq: "awards" } }
      limit: 1
    ) {
      edges {
        node {
          name
          description
          quote
          bg {
            fluid(maxWidth: 1000) {
              src
            }
          }
        }
      }
    }
    allContentfulAward(
      sort: {
        fields: [bestIndex, orderRank, internalOrderRank, createdAt]
        order: [ASC, DESC, DESC, DESC]
      }
    ) {
      edges {
        node {
          id
          name
          prize
          time
          certificate {
            fluid(maxWidth: 1000) {
              src
            }
          }
        }
      }
    }
    allContentfulSocialMedia(
      sort: { fields: [orderRank, createdAt], order: ASC }
    ) {
      edges {
        node {
          fontclass
          color
          url
          title
        }
      }
    }
  }
`
